import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

import marker from "../assets/loc_marker.png";

const customIcon = L.icon({
  iconUrl: marker,
  iconSize: [40, 60],
  iconAnchor: [20, 60],
  popupAnchor: [0, -60],
});

const position = [13.712496549335643, 100.36434864672832];

function LocationMap() {
  return (
    <MapContainer
      center={position}
      zoom={13}
      scrollWheelZoom={true}
      style={{
        height: "100%",
        width: "100%",
        overflow: "hidden",
      }}
      minZoom={3}
    >
      <TileLayer
        attribution='&copy; OpenStreetMap contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      <Marker position={position} icon={customIcon}>
        <Popup>
          <div style={{ textAlign: "center" }}>
            HOPBON CO., LTD.
            <br />
            This is where we are.
            <br />

            <a
              href="https://maps.app.goo.gl/4fLPDyRZXHn9fPHGA?g_st=il"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#1976d2",
                textDecoration: "underline",
              }}
            >
              View on Google Maps
            </a>
          </div>
        </Popup>
      </Marker>
    </MapContainer>
  );
}

export default LocationMap;